import { IconButton, InputAdornment } from '@mui/material'
import { PiEye, PiEyeClosed } from 'react-icons/pi'

const EyeMaskEndAdornment = ({ onClick, isMasked }) => (
  <InputAdornment position="end">
    <IconButton
      onClick={onClick}
      // aria-label="submit message"
      edge="end">
      {isMasked
        ? <PiEyeClosed fill='white' />
        : <PiEye fill='white' />
      }
    </IconButton>
  </InputAdornment>
)

export { EyeMaskEndAdornment }
